import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import MenuCart from './sub-components/MenuCart';
import { authSelector, logout } from '../../store/slices/auth-slice';

const IconGroup = ({ iconWhiteClass }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {t,i18n} =  useTranslation();

  const handleClick = (e) => {
    e.currentTarget.nextSibling.classList.toggle('active');
  };
  const changeLanguageTrigger = e => {
    const languageCode = e.target.value;
    i18n.changeLanguage(languageCode);
  };
  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      '#offcanvas-mobile-menu'
    );
    offcanvasMobileMenu.classList.add('active');
  };
  // const { compareItems } = useSelector((state) => state.compare);
  // const { wishlistItems } = useSelector((state) => state.wishlist);
  const { accessToken, cartProductCount } = useSelector(authSelector);
  const isAuthenticated = !!accessToken;

  return (
    <div className={clsx('header-right-wrap', iconWhiteClass)}>
      {/* <div className="same-style header-search d-none d-lg-block">
        <button className="search-active" onClick={(e) => handleClick(e)}>
          <i className="pe-7s-search" />
        </button>
        <div className="search-content">
          <form action="#">
            <input type="text" placeholder="Search" />
            <button className="button-search">
              <i className="pe-7s-search" />
            </button>
          </form>
        </div>
      </div> */}
    <div className="language-currency-wrap ">
     <div className="same-language-currency language-style">
        <span className='language-dropdown'>
          {i18n.resolvedLanguage === "en"
            ? "English"
            : i18n.resolvedLanguage === "zh"
            ? "Chinese"
            : i18n.resolvedLanguage === "it"
            ? "Italian"
            : ""}{" "}
          <i className="fa fa-angle-down" />
        </span>
        <div className="lang-car-dropdown">
          <ul>
            <li>
              <button value="en" onClick={e => changeLanguageTrigger(e)}>
                English
              </button>
            </li>
            <li>
              <button value="zh" onClick={e => changeLanguageTrigger(e)}>
                Chinese
              </button>
            </li>
              <li>
              <button value="it" onClick={e => changeLanguageTrigger(e)}>
                Italian
              </button>
            </li>
          </ul>
        </div>
      </div>
      </div>

      <div className="same-style account-setting d-none d-lg-block">
        
        <button
          className="account-setting-active"
          onClick={(e) => handleClick(e)}
        >
          <i className="pe-7s-user-female" />
        </button>
        <div className="account-dropdown">
          <ul>
            {isAuthenticated ? (
              <>
                <li>
                  <Link to={process.env.PUBLIC_URL + '/my-account'}>
                    {t("my account")}
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    onClick={() => {
                      dispatch(logout());
                    }}
                  >
                    {t("Logout")}
                  </Link>
                </li>
              </>
            ) : (
              <>
                <li>
                  <Link to={process.env.PUBLIC_URL + '/login'}>{t("Login")}</Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
      {/* <div className="same-style header-compare">
        <Link to={process.env.PUBLIC_URL + '/compare'}>
          <i className="pe-7s-shuffle" />
          <span className="count-style">
            {compareItems && compareItems.length ? compareItems.length : 0}
          </span>
        </Link>
      </div>
      <div className="same-style header-wishlist">
        <Link to={process.env.PUBLIC_URL + '/wishlist'}>
          <i className="pe-7s-like" />
          <span className="count-style">
            {wishlistItems && wishlistItems.length ? wishlistItems.length : 0}
          </span>
        </Link>
      </div> */}
      <div className="same-style cart-wrap d-none d-lg-block">
        <button
          className="icon-cart"
          onClick={(e) => {
            // handleClick(e);
            navigate('/cart');
          }}
        >
          <i className="pe-7s-shopbag" />
          <span className="count-style">
            {cartProductCount || 0}
          </span>
        </button>
        {/* menu cart */}
        <MenuCart />
      </div>
      <div className="same-style cart-wrap d-block d-lg-none">
        <Link className="icon-cart" to={process.env.PUBLIC_URL + '/cart'}>
          <i className="pe-7s-shopbag" />
          <span className="count-style">
            {cartProductCount || 0}
          </span>
        </Link>
      </div>
      <div className="same-style mobile-off-canvas d-block d-lg-none">
        <button
          className="mobile-aside-button"
          onClick={() => triggerMobileMenu()}
        >
          <i className="pe-7s-menu" />
        </button>
      </div>
    </div>
  );
};

IconGroup.propTypes = {
  iconWhiteClass: PropTypes.string,
};

export default IconGroup;
